
























import Vue          from 'vue'

import store    from '@/store';
import SignIn 	from '@/components/btn-signin.vue';

export default Vue.extend({
  components: {
    'sign-in': SignIn
  },
  props: ['allowAlt'],
  data() {
		return {
      scrollPosition: 0,
      isAlt: true,
		}
	},
  methods: {
    goApp() {
      this.$router.push('/app')
    },
    updateScroll() {
      this.scrollPosition = window.scrollY
			if (this.scrollPosition > 600) {
        this.isAlt = false;
      } else {
        this.isAlt = true;
      }
		}
  },
	mounted() {
		window.addEventListener('scroll', this.updateScroll);
	},
});
